import { getChipLabel } from "../../../components/chips/CustomChip";
import { queryClient } from "../../../main";
import { formatDate } from "../../../utils/dateUtils";
import { findField } from "../../../utils/findField";
import { formatClientName } from "./utils";

export const renderOrderSelectedOption = (option: any) => {
    const fields = queryClient.getQueryData(["orders_payments-fields"]) as any;
    const paymentField = fields ? findField(fields, "payment_method") : null;
    const clientName = formatClientName(option?.order?.treatment?.client?.user_id?.first_name || "", option?.order?.treatment?.client?.user_id?.last_name || "");
    
    if (paymentField) {
        paymentField.settings = paymentField.meta;
    }
    const paymentFieldLabel = paymentField ? getChipLabel(paymentField, option?.payment_method) : (option?.payment_method || "");

    return `${formatDate(option?.payment_date || "")}: ${option?.order?.treatment?.client?.client_id || ""} ${clientName} - ${option?.amount || 0}€ (${paymentFieldLabel})`;
};
